module.exports = __webpack_public_path__ + "img/logo-solar.45c94d67.png";